export default {
    token: null,
    user: null
};